import { inject } from "@angular/core";
import { Auth, GoogleAuthProvider, signInWithRedirect, user } from "@angular/fire/auth";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { catchError, map, of, switchMap } from "rxjs";
import { AuthzService } from "./authz.service";

export const hasPermission: CanActivateFn = 
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const authzService = inject(AuthzService);
    const eventKey = route.paramMap.get('eventKey');

    if(!eventKey) return false;

    return authzService.isAuthorized(eventKey).pipe(
      switchMap(async isAuthorized => {
        if (isAuthorized) return true;

        // window.location.href = `${environment.mainHostUrl}/login`;

        return false;
      }),
      catchError(() => {
        return of(router.parseUrl(`/error?url=${getResolvedUrl(route)}`));
      }),
    );
  };

function getResolvedUrl(route: ActivatedRouteSnapshot): string {
  return route.pathFromRoot
    .map(v => v.url.map(segment => segment.toString()).join('/'))
    .join('/');
}

export const isLoggedIn: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(Auth);

    return user(auth).pipe(
      map(u => {
        if(u) return true;

        signInWithRedirect(auth, new GoogleAuthProvider());

        return false;
      }),
    );
  };

export const isSuperAdmin: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const db = inject(AuthzService);

    return db.isSuperAdmin();
  };

export const isLoggedInNonAnon: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const auth = inject(Auth);
    const router = inject(Router);

    return user(auth).pipe(
      map(u => {
        if(u && !u.isAnonymous) return true;

        return router.parseUrl(`/login?redirect=${encodeURIComponent(state.url)}&nonAnon=true`);
      }),
    );
  };